import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import slice from 'ramda/src/slice';
import Accordion from '@components/@core/Accordion';
import Filter from '@components/@core/Filter';
import Input from '@components/@core/Input';
import Pagination from '@components/@core/Pagination';
import Thumbnail from '@components/@core/Thumbnail';
import Toggle from '@components/@core/Toggle';
import EditDropdown from '@components/EditDropdown';
import Settings from '@components/@core/Settings';
import moment from 'moment';
import { LibraryCardDetailMenu } from '~/services/config';
import { getSettings, inPage } from '~/services/util';
import Course from './Course';

const Detail = ({ data, onCardMenu, onChildMenu }) => {
    const [page, setPage] = useState(1);
    const [per, setPer] = useState(5);
    const role = useSelector((state) => state.app.app_role_id);
    const authors = useSelector((state) => state.app.authors);
    const departments = useSelector((state) => state.app.departments);
    const competencies = useSelector((state) => state.app.competencies);
    const categories = useSelector((state) => state.app.categories);
    const courses = data.data?.cards || [];
    const from = (page - 1) * per;
    const to = page * per;
    const selected = slice(from, to, courses);

    const settings = [
        { name: 'Author', id: [data.author_id], options: authors },
        { name: 'Departments', id: data.data.department, options: departments },
        { name: 'Competencies', id: data.data.competency, options: competencies },
        { name: 'Categories', id: data.data.category, options: categories },
    ];
    const stats = [
        { name: 'Created', value: moment(data?.created_at).format('MMM DD, YY') || null },
        { name: 'Created By', value: data?.created_by || 'Na' },
        { name: 'Last Edited', value: moment(data?.updated_at).format('MMM DD, YY') || null },
        { name: 'Last edits by', value: data?.edited_by || 'Na' },
        { name: 'Assigned', value: data?.assigned || 'Na' },
    ];

    return (
        <>
            <Filter back="all tracks" />
            <div className="library-track-card border-5">
                <div className="detail-content">
                    <div className="d-flex jc-between">
                        <p className="dsl-b22 bold">Track</p>
                        <div className="desktop-block">
                            <EditDropdown options={LibraryCardDetailMenu[role]} onChange={onCardMenu} />
                        </div>
                    </div>
                    <div className="d-flex jc-between ssm-column">
                        <div className="ssm-100 w-50 w-sm-100 mb-3">
                            <div className="d-flex ai-center ps-1 mb-3">
                                <div className="career-text dsl-b12">Name</div>
                                <p className="dsl-b16 text-400 truncate-one mb-0">{data?.name || data?.title}</p>
                            </div>
                            <div className="d-flex ai-start ps-1 mb-3">
                                <p className="career-text dsl-b12 pt-1 m-0">Description</p>
                                <p className="dsl-b16 description mb-0">{data?.description || data?.data?.description}</p>
                            </div>
                        </div>
                        <div className="ssm-100 w-40 w-sm-100">
                            <Thumbnail source={data.thumbnail || data.data.thumbnail} size="medium" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="library-track-card mt-3 border-5">
                <div className="modules-content">
                    <div className="modules-header">
                        <span className="dsl-b18 bold">Courses</span>
                    </div>
                    <Course data={selected} role={role} onMenu={onChildMenu} menu={false} />
                    {data?.data?.cards?.length > 0 && (
                        <Pagination
                            current={page}
                            per={per}
                            pers={data?.data?.cards.length > 5 ? [5, 10, 'all'] : []}
                            total={Math.ceil(data?.data?.cards?.length / per)}
                            onChange={(e) => setPage(e)}
                            onPer={(e) => setPer(e)}
                        />
                    )}
                </div>
            </div>
            <Settings values={settings} stats={stats} />
        </>
    );
};

export default Detail;
